/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Printer: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <g clipPath='url(#clip0_21777_31516)'>
      <path
        d='M20 4H18V2H6V4H4V1C4 0.734784 4.10536 0.48043 4.29289 0.292893C4.48043 0.105357 4.73478 0 5 0L19 0C19.2652 0 19.5196 0.105357 19.7071 0.292893C19.8946 0.48043 20 0.734784 20 1V4Z'
        fill='currentColor'
      />
      <path
        d='M21 6H3C2.20435 6 1.44129 6.31607 0.87868 6.87868C0.31607 7.44129 0 8.20435 0 9L0 18C0 18.2652 0.105357 18.5196 0.292893 18.7071C0.48043 18.8946 0.734784 19 1 19H4V23C4 23.2652 4.10536 23.5196 4.29289 23.7071C4.48043 23.8946 4.73478 24 5 24H19C19.2652 24 19.5196 23.8946 19.7071 23.7071C19.8946 23.5196 20 23.2652 20 23V19H23C23.2652 19 23.5196 18.8946 23.7071 18.7071C23.8946 18.5196 24 18.2652 24 18V9C24 8.20435 23.6839 7.44129 23.1213 6.87868C22.5587 6.31607 21.7956 6 21 6ZM18 22H6V13H18V22Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_21777_31516'>
        <rect width='24' height='24' fill='currentColor' />
      </clipPath>
    </defs>
  </React.Fragment>
)
